import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, shareReplay, tap, throwError } from 'rxjs';
import { Api } from './api';
import { environment } from '../../../environments/environment';
import { SessionService } from '../services/session';
import { Token } from '../services/token';
import { AuthService } from './auth';

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  private domainDetails$?: Observable<any>;

  constructor(
    private api: Api,
    private session: SessionService,
    private tokenService: Token,private authService:AuthService
  ) {}

  getDomainDetails(req: any) {
    if (!this.domainDetails$) {
      this.domainDetails$ = this.api.post<any>(
        environment.apiVersions.v1,
        'getDomainDetails',
        req
      ).pipe(
        tap(res => {
          if (res?.Token) {
            this.tokenService.setToken(res.Token);
            this.authService.setTokenFromDomain(res.Token);
          }

          if (res?.SessId) {
            sessionStorage.setItem('sessId', res.SessId);
          }

          this.session.setDomainDetails(res);
          this.session.setSession(res);
        }),
        catchError((error) => {
          // Avoid sticky errored cache; allow next call to retry fresh.
          this.domainDetails$ = undefined;
          return throwError(() => error);
        }),
        shareReplay(1)
      );
    }

    return this.domainDetails$;
  }

  ensureDomainContext(forceRefresh = false): Observable<boolean> {
    const hasContext = this.session.hasRequiredDomainContext();
    const hasToken = !!this.tokenService.getToken();

    if (hasContext && hasToken && !forceRefresh) {
      return of(true);
    }

    if (forceRefresh) {
      this.resetDomainCache();
    }

    const input = {
      Route: 'adms_form',
      Domain: window.location.host,
    };

    return this.getDomainDetails(input).pipe(
      map(() => this.session.hasRequiredDomainContext() && !!this.tokenService.getToken()),
      catchError(() => of(false))
    );
  }

  resetDomainCache(): void {
    this.domainDetails$ = undefined;
  }
}
